export const environment = {
  production: true,
  apiUrl: 'https://insuredportalapi.mpiua.com/api/',
  companyCode: 'MPI',
  mpiProducerUrl:'https://apps.mpiua.com/',
  rijProducerUrl:'https://apps.rijra.com/'
};
